export function createLocalPreviewUrl(file) {
  if (!file) return null;
  return URL.createObjectURL(file);
}

export function revokeLocalPreviewUrl(url) {
  if (url && url.startsWith('blob:')) {
    URL.revokeObjectURL(url);
  }
}
